import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Box, Button, HStack, Link, Wrap, WrapItem } from "@chakra-ui/react";
import React, { FC } from "react";
import { Else, If, Then } from "react-if";
import { IAction } from "../models/banner";
import CalendlyButton from "./CalendlyButton";
import DownloadButton from "./DownloadButton";
import useCalendlyModal from "../hooks/useCalendlyModal";

interface iProps {
  actions?: IAction[];
  groupPt?: any;
  groupPb?: any;
  buttonSize?: any;
}

const ActionButton: FC<iProps> = (props) => {
  const { actions, groupPt = 7, groupPb = 7, buttonSize = "auto" } = props;

  const { isCalendlyModalOpen, openCalendlyModal, closeCalendlyModal } =
    useCalendlyModal();

  if (actions === undefined || actions.length === 0 || actions === null) {
    return null;
  }

  return (
    <Box pt={groupPt} pb={groupPb} width={buttonSize}>
      <Wrap spacing="4">
        {actions?.map((item, index) => {
          return (
            <WrapItem key={index} width={buttonSize}>
              <If condition={item?.type == "download"}>
                <Then>
                  <DownloadButton
                    label={item?.label}
                    item={item?.resource?.data}
                    variant={item?.variant}
                    width={buttonSize}
                  />
                </Then>
                <Else>
                  <If condition={item?.type == "schedule-demo"}>
                    <Then>
                      <CalendlyButton
                        label={item?.label}
                        variant={item?.variant}
                        width={buttonSize}
                        isOpen={isCalendlyModalOpen}
                        onOpenModal={openCalendlyModal}
                        onCloseModal={closeCalendlyModal}
                      />
                    </Then>

                    <Else>
                      <If condition={!!item?.pdf_link?.data}>
                        <Then>
                          <Link
                            href={item?.pdf_link?.data?.attributes?.url}
                            target="_blank"
                            data-is-external
                            _hover={{ textDecoration: "none" }}
                            width={buttonSize}
                          >
                            <HStack width={buttonSize}>
                              <Button
                                textStyle={"hind_m"}
                                variant={item.variant}
                                width={buttonSize}
                              >
                                {item.label}
                                <If condition={item?.icon != undefined}>
                                  <Then>
                                    <ArrowForwardIcon
                                      color={"primary"}
                                      boxSize={5}
                                    />
                                  </Then>
                                </If>
                              </Button>
                            </HStack>
                          </Link>
                        </Then>
                        <Else>
                          <Link
                            href={item.slug}
                            _hover={{ textDecoration: "none" }}
                            width={buttonSize}
                          >
                            <HStack width={buttonSize}>
                              <Button
                                textStyle={"hind_m"}
                                variant={item.variant}
                                width={buttonSize}
                              >
                                {item.label}

                                <If condition={item?.icon != undefined}>
                                  <Then>
                                    <ArrowForwardIcon
                                      color={"primary"}
                                      boxSize={5}
                                    />
                                  </Then>
                                </If>
                              </Button>
                            </HStack>
                          </Link>
                        </Else>
                      </If>
                    </Else>
                  </If>
                </Else>
              </If>
            </WrapItem>
          );
        })}
      </Wrap>
    </Box>
  );
};

export default ActionButton;
